
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as oryp1AqPzQw7k2CdSk9wY2n2pu_MDYbMAtwrHLWQUI_45GiMMeta } from "/build/incl/pages/ory.vue?macro=true";
import { default as liveCD9WWhFHbbR7tg_45CuABya4UlmebpVhjGxlMwSq71if0Meta } from "/build/incl/pages/live.vue?macro=true";
import { default as indexUrIPA1LVRbGONso3z_Y_NE1o8gpuEVAwMTDWLxZc5oQMeta } from "/build/incl/pages/index.vue?macro=true";
import { default as box_45officesn7igMTSxXVq4zfh0AlGQy71qhGJ1yrMj3Ih1khJzkUMeta } from "/build/incl/pages/box-office.vue?macro=true";
import { default as teamsHI4ZXQNj0PCp07odMit8IG3oddYseCCNJr7lU6S6Bf8Meta } from "/build/incl/pages/admin/teams.vue?macro=true";
import { default as users9uDKxsCubVrQzuBeud2nEeVEeyXNfh5Au4zHxZDI0qMMeta } from "/build/incl/pages/admin/users.vue?macro=true";
import { default as indexzFObHOqlcI7gEk7Ap4pCTk6RpMoOKLLp1GDzuBE3g34Meta } from "/build/incl/pages/judge/index.vue?macro=true";
import { default as sharingSghbv5Vuh9yFsetND5CpPKReIndGN7XnwsbFVPU7w4UMeta } from "/build/incl/pages/admin/sharing.vue?macro=true";
import { default as indexd0dYP8eezP4prIMFg2umiGrjlPtFiG1qizF5qSUkktYMeta } from "/build/incl/pages/archive/index.vue?macro=true";
import { default as save_45the_45datesiiga4OTgZrtS8INkxrEqb67qkQddeCzHQHupDBh6RMcMeta } from "/build/incl/pages/save-the-dates.vue?macro=true";
import { default as indexBKR2tkqWgiH_vEdwP3C5xRkdYH5D2P8897kmY47PHkoMeta } from "/build/incl/pages/selection/index.vue?macro=true";
import { default as imagesexuoUPy8C8oWnWQKgSVIQ0kFmH4kosvXUerhMwUUwF4Meta } from "/build/incl/pages/admin/mam/images.vue?macro=true";
import { default as videosB3Y2WXPP3lOzk_45Tn8ibk3AA8LLhxrb1iqRKhhBOtD9cMeta } from "/build/incl/pages/admin/mam/videos.vue?macro=true";
import { default as judgepIdIRoJc_0HDC0RxUXy7pfnM4cUnvcTj6b7W1Dynm2QMeta } from "/build/incl/pages/admin/results/judge.vue?macro=true";
import { default as _91filmGroupId_93tm0QG_dnn3YVE6do_uRIHm_45biFDjA7akdMouEQDBW8gMeta } from "/build/incl/pages/judge/[filmGroupId].vue?macro=true";
import { default as indexDkqZo3iQrnW0ZcjWIATMz2nEjKfcfed7bec4xyE4BXkMeta } from "/build/incl/pages/prize-sponsor/index.vue?macro=true";
import { default as indexcFkoDdB7HoX1KTYVEaBiZ0i6886D3pZ92tmH3gc86JAMeta } from "/build/incl/pages/film-challenge/index.vue?macro=true";
import { default as exit_45interviewsWNdSBkVNE1Ca1Lma_LaUGe8IUpuGdeEqd9k67o3LhnIMeta } from "/build/incl/pages/admin/exit-interviews.vue?macro=true";
import { default as academy2Il9jadQtxyB86RX5bPfWWTUPyk6rDitytv70s3x9lUMeta } from "/build/incl/pages/admin/results/academy.vue?macro=true";
import { default as top_4510lxVGjQ4qxGr_45lm0MAB6powoLNAfocCWA2_iskRzRUBkMeta } from "/build/incl/pages/archive/[year]/top-10.vue?macro=true";
import { default as createEkBK2FrRdzxS_45bc0wztX6arIy5ZWJBGh7mUaMcwbiboMeta } from "/build/incl/pages/fivefest/films/create.vue?macro=true";
import { default as indexEDwisKdQM0lWUM0qP6o_BSAbEOKLcZjZwb9dFX7HfVcMeta } from "/build/incl/pages/fivefest/academy/index.vue?macro=true";
import { default as indexpRXNOruHMjjYcVvkuK_45uVGg75usWKDGiVCxzcj4_45Tz8Meta } from "/build/incl/pages/online-screening/index.vue?macro=true";
import { default as filmsvGYwJAa_45HBhqKxN2GvymK2HXNDiSj2zBPdDycSwqxiUMeta } from "/build/incl/pages/admin/film-groups/films.vue?macro=true";
import { default as userseuILGxupdVvrfT8NhqYwxWPQTLX_bJWtl2HJ51LYxjAMeta } from "/build/incl/pages/admin/film-groups/users.vue?macro=true";
import { default as selectionSCrlwFnUJM12hv66r_45PAVw9uYNRqFni7A5CAuM_45DinYMeta } from "/build/incl/pages/admin/results/selection.vue?macro=true";
import { default as _91teamId_93xskxNE9mYdJ_4589wgGX6Hu9gn3kVqKjZoOKZaALfalHAMeta } from "/build/incl/pages/archive/[year]/[teamId].vue?macro=true";
import { default as inspirationYYPLkItHc1WXeBCux84cfDFqJ6_e_45hNw0GMNU9SATMkMeta } from "/build/incl/pages/film-challenge/inspiration.vue?macro=true";
import { default as the_45matchupQQa_cfRzEZFjom3NsLs7ZHp4BQiUjvrR0M45k4rJJYwMeta } from "/build/incl/pages/film-challenge/the-matchup.vue?macro=true";
import { default as indexX0rqJiGhjhSK8iVLZdpK3frf4fwUupV1Mjvg6YfRqJkMeta } from "/build/incl/pages/admin/audience-favorite/index.vue?macro=true";
import { default as checkin_16RLIFsheEBLes8llqQ61HVvtd6vcQf_45e2cm4JyxVAMeta } from "/build/incl/pages/admin/awards-ceremony/checkin.vue?macro=true";
import { default as _91submissionId_933DqWLTY3fTviFNX8Wv6VrSNAvMDRLya9hJYnEZo1hCgMeta } from "/build/incl/pages/fivefest/films/[submissionId].vue?macro=true";
import { default as indexhkqA9n7hgIAHh0iYlM817CqMz5aPMxsR5MktmOlv9W8Meta } from "/build/incl/pages/selection/[filmGroupId]/index.vue?macro=true";
import { default as _91filmGroupId_93VepQ0Crf0AlAUy_ghmlHHlNYokgb6bWlu8lh3x_jWRUMeta } from "/build/incl/pages/online-screening/[filmGroupId].vue?macro=true";
import { default as reviewirXv0gPSFK6PiuXXLOexBuD0XjCIjSRb7KE_45Y2hTZ_45AMeta } from "/build/incl/pages/selection/[filmGroupId]/review.vue?macro=true";
import { default as indexOFjQ9XB1BQx8Ideaq0kNfYOe_45gxYeLaxZO0TMCczTFAMeta } from "/build/incl/pages/online-screening/five-fest/index.vue?macro=true";
import { default as _91filmGroupId_93WQZwPOA609JX7TlVAMLKGEsdn3Tg4TApveEZ7hpf62IMeta } from "/build/incl/pages/admin/audience-favorite/[filmGroupId].vue?macro=true";
import { default as index3jhHoFoRQrIJXxIlKJjv_45E8dBLFHuNSoUmOb_GPsE7gMeta } from "/build/incl/pages/film-challenge/studios/[studioId]/index.vue?macro=true";
import { default as _91hash_93zER179T2yvVKapICOIeKdZY8SpQFpi1ZJ6X1BqITnDIMeta } from "/build/incl/pages/film-challenge/guest-registration/[hash].vue?macro=true";
import { default as _91filmGroupId_93kGdNuzSyAOx1U6D_45yJMpP_l70rsXrc3oPFwt6t5vMc0Meta } from "/build/incl/pages/online-screening/five-fest/[filmGroupId].vue?macro=true";
import { default as _91filmGroupId_930tbFWWYp6vF8L9wpJFfYa6fK5D4VoZC_45Coue9G0HACIMeta } from "/build/incl/pages/fivefest/academy/film-groups/[filmGroupId].vue?macro=true";
import { default as createVTWnBRbU0ZYcQQFnEbbzcXhJwN2PZFR9WHiwtdjOutEMeta } from "/build/incl/pages/film-challenge/studios/[studioId]/teams/create.vue?macro=true";
import { default as _91teamId_93BzC8VqAlxC5IIRKMa_45_45_45jwxN_45q_45e7SQdaNqk8htgvjwMeta } from "/build/incl/pages/film-challenge/studios/[studioId]/teams/[teamId].vue?macro=true";
export default [
  {
    name: "ory",
    path: "/ory",
    component: () => import("/build/incl/pages/ory.vue")
  },
  {
    name: "live",
    path: "/live",
    component: () => import("/build/incl/pages/live.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/build/incl/pages/index.vue")
  },
  {
    name: "box-office",
    path: "/box-office",
    meta: box_45officesn7igMTSxXVq4zfh0AlGQy71qhGJ1yrMj3Ih1khJzkUMeta || {},
    component: () => import("/build/incl/pages/box-office.vue")
  },
  {
    name: "admin-teams",
    path: "/admin/teams",
    meta: teamsHI4ZXQNj0PCp07odMit8IG3oddYseCCNJr7lU6S6Bf8Meta || {},
    component: () => import("/build/incl/pages/admin/teams.vue")
  },
  {
    name: "admin-users",
    path: "/admin/users",
    meta: users9uDKxsCubVrQzuBeud2nEeVEeyXNfh5Au4zHxZDI0qMMeta || {},
    component: () => import("/build/incl/pages/admin/users.vue")
  },
  {
    name: "judge",
    path: "/judge",
    meta: indexzFObHOqlcI7gEk7Ap4pCTk6RpMoOKLLp1GDzuBE3g34Meta || {},
    component: () => import("/build/incl/pages/judge/index.vue")
  },
  {
    name: "admin-sharing",
    path: "/admin/sharing",
    meta: sharingSghbv5Vuh9yFsetND5CpPKReIndGN7XnwsbFVPU7w4UMeta || {},
    component: () => import("/build/incl/pages/admin/sharing.vue")
  },
  {
    name: "archive",
    path: "/archive",
    component: () => import("/build/incl/pages/archive/index.vue")
  },
  {
    name: "save-the-dates",
    path: "/save-the-dates",
    component: () => import("/build/incl/pages/save-the-dates.vue")
  },
  {
    name: "selection",
    path: "/selection",
    meta: indexBKR2tkqWgiH_vEdwP3C5xRkdYH5D2P8897kmY47PHkoMeta || {},
    component: () => import("/build/incl/pages/selection/index.vue")
  },
  {
    name: "admin-mam-images",
    path: "/admin/mam/images",
    meta: imagesexuoUPy8C8oWnWQKgSVIQ0kFmH4kosvXUerhMwUUwF4Meta || {},
    component: () => import("/build/incl/pages/admin/mam/images.vue")
  },
  {
    name: "admin-mam-videos",
    path: "/admin/mam/videos",
    meta: videosB3Y2WXPP3lOzk_45Tn8ibk3AA8LLhxrb1iqRKhhBOtD9cMeta || {},
    component: () => import("/build/incl/pages/admin/mam/videos.vue")
  },
  {
    name: "admin-results-judge",
    path: "/admin/results/judge",
    meta: judgepIdIRoJc_0HDC0RxUXy7pfnM4cUnvcTj6b7W1Dynm2QMeta || {},
    component: () => import("/build/incl/pages/admin/results/judge.vue")
  },
  {
    name: "judge-filmGroupId",
    path: "/judge/:filmGroupId()",
    meta: _91filmGroupId_93tm0QG_dnn3YVE6do_uRIHm_45biFDjA7akdMouEQDBW8gMeta || {},
    component: () => import("/build/incl/pages/judge/[filmGroupId].vue")
  },
  {
    name: "prize-sponsor",
    path: "/prize-sponsor",
    component: () => import("/build/incl/pages/prize-sponsor/index.vue")
  },
  {
    name: "film-challenge",
    path: "/film-challenge",
    meta: indexcFkoDdB7HoX1KTYVEaBiZ0i6886D3pZ92tmH3gc86JAMeta || {},
    component: () => import("/build/incl/pages/film-challenge/index.vue")
  },
  {
    name: "admin-exit-interviews",
    path: "/admin/exit-interviews",
    meta: exit_45interviewsWNdSBkVNE1Ca1Lma_LaUGe8IUpuGdeEqd9k67o3LhnIMeta || {},
    component: () => import("/build/incl/pages/admin/exit-interviews.vue")
  },
  {
    name: "admin-results-academy",
    path: "/admin/results/academy",
    meta: academy2Il9jadQtxyB86RX5bPfWWTUPyk6rDitytv70s3x9lUMeta || {},
    component: () => import("/build/incl/pages/admin/results/academy.vue")
  },
  {
    name: "archive-year-top-10",
    path: "/archive/:year()/top-10",
    component: () => import("/build/incl/pages/archive/[year]/top-10.vue")
  },
  {
    name: "fivefest-films-create",
    path: "/fivefest/films/create",
    meta: createEkBK2FrRdzxS_45bc0wztX6arIy5ZWJBGh7mUaMcwbiboMeta || {},
    component: () => import("/build/incl/pages/fivefest/films/create.vue")
  },
  {
    name: "fivefest-academy",
    path: "/fivefest/academy",
    meta: indexEDwisKdQM0lWUM0qP6o_BSAbEOKLcZjZwb9dFX7HfVcMeta || {},
    component: () => import("/build/incl/pages/fivefest/academy/index.vue")
  },
  {
    name: "online-screening",
    path: "/online-screening",
    meta: indexpRXNOruHMjjYcVvkuK_45uVGg75usWKDGiVCxzcj4_45Tz8Meta || {},
    component: () => import("/build/incl/pages/online-screening/index.vue")
  },
  {
    name: "admin-film-groups-films",
    path: "/admin/film-groups/films",
    meta: filmsvGYwJAa_45HBhqKxN2GvymK2HXNDiSj2zBPdDycSwqxiUMeta || {},
    component: () => import("/build/incl/pages/admin/film-groups/films.vue")
  },
  {
    name: "admin-film-groups-users",
    path: "/admin/film-groups/users",
    meta: userseuILGxupdVvrfT8NhqYwxWPQTLX_bJWtl2HJ51LYxjAMeta || {},
    component: () => import("/build/incl/pages/admin/film-groups/users.vue")
  },
  {
    name: "admin-results-selection",
    path: "/admin/results/selection",
    meta: selectionSCrlwFnUJM12hv66r_45PAVw9uYNRqFni7A5CAuM_45DinYMeta || {},
    component: () => import("/build/incl/pages/admin/results/selection.vue")
  },
  {
    name: "archive-year-teamId",
    path: "/archive/:year()/:teamId()",
    component: () => import("/build/incl/pages/archive/[year]/[teamId].vue")
  },
  {
    name: "film-challenge-inspiration",
    path: "/film-challenge/inspiration",
    component: () => import("/build/incl/pages/film-challenge/inspiration.vue")
  },
  {
    name: "film-challenge-the-matchup",
    path: "/film-challenge/the-matchup",
    meta: the_45matchupQQa_cfRzEZFjom3NsLs7ZHp4BQiUjvrR0M45k4rJJYwMeta || {},
    component: () => import("/build/incl/pages/film-challenge/the-matchup.vue")
  },
  {
    name: "admin-audience-favorite",
    path: "/admin/audience-favorite",
    meta: indexX0rqJiGhjhSK8iVLZdpK3frf4fwUupV1Mjvg6YfRqJkMeta || {},
    component: () => import("/build/incl/pages/admin/audience-favorite/index.vue")
  },
  {
    name: "admin-awards-ceremony-checkin",
    path: "/admin/awards-ceremony/checkin",
    meta: checkin_16RLIFsheEBLes8llqQ61HVvtd6vcQf_45e2cm4JyxVAMeta || {},
    component: () => import("/build/incl/pages/admin/awards-ceremony/checkin.vue")
  },
  {
    name: "fivefest-films-submissionId",
    path: "/fivefest/films/:submissionId()",
    meta: _91submissionId_933DqWLTY3fTviFNX8Wv6VrSNAvMDRLya9hJYnEZo1hCgMeta || {},
    component: () => import("/build/incl/pages/fivefest/films/[submissionId].vue")
  },
  {
    name: "selection-filmGroupId",
    path: "/selection/:filmGroupId()",
    meta: indexhkqA9n7hgIAHh0iYlM817CqMz5aPMxsR5MktmOlv9W8Meta || {},
    component: () => import("/build/incl/pages/selection/[filmGroupId]/index.vue")
  },
  {
    name: "online-screening-filmGroupId",
    path: "/online-screening/:filmGroupId()",
    meta: _91filmGroupId_93VepQ0Crf0AlAUy_ghmlHHlNYokgb6bWlu8lh3x_jWRUMeta || {},
    component: () => import("/build/incl/pages/online-screening/[filmGroupId].vue")
  },
  {
    name: "selection-filmGroupId-review",
    path: "/selection/:filmGroupId()/review",
    meta: reviewirXv0gPSFK6PiuXXLOexBuD0XjCIjSRb7KE_45Y2hTZ_45AMeta || {},
    component: () => import("/build/incl/pages/selection/[filmGroupId]/review.vue")
  },
  {
    name: "online-screening-five-fest",
    path: "/online-screening/five-fest",
    meta: indexOFjQ9XB1BQx8Ideaq0kNfYOe_45gxYeLaxZO0TMCczTFAMeta || {},
    component: () => import("/build/incl/pages/online-screening/five-fest/index.vue")
  },
  {
    name: "admin-audience-favorite-filmGroupId",
    path: "/admin/audience-favorite/:filmGroupId()",
    meta: _91filmGroupId_93WQZwPOA609JX7TlVAMLKGEsdn3Tg4TApveEZ7hpf62IMeta || {},
    component: () => import("/build/incl/pages/admin/audience-favorite/[filmGroupId].vue")
  },
  {
    name: "film-challenge-studios-studioId",
    path: "/film-challenge/studios/:studioId()",
    meta: index3jhHoFoRQrIJXxIlKJjv_45E8dBLFHuNSoUmOb_GPsE7gMeta || {},
    component: () => import("/build/incl/pages/film-challenge/studios/[studioId]/index.vue")
  },
  {
    name: "film-challenge-guest-registration-hash",
    path: "/film-challenge/guest-registration/:hash()",
    meta: _91hash_93zER179T2yvVKapICOIeKdZY8SpQFpi1ZJ6X1BqITnDIMeta || {},
    component: () => import("/build/incl/pages/film-challenge/guest-registration/[hash].vue")
  },
  {
    name: "online-screening-five-fest-filmGroupId",
    path: "/online-screening/five-fest/:filmGroupId()",
    meta: _91filmGroupId_93kGdNuzSyAOx1U6D_45yJMpP_l70rsXrc3oPFwt6t5vMc0Meta || {},
    component: () => import("/build/incl/pages/online-screening/five-fest/[filmGroupId].vue")
  },
  {
    name: "fivefest-academy-film-groups-filmGroupId",
    path: "/fivefest/academy/film-groups/:filmGroupId()",
    meta: _91filmGroupId_930tbFWWYp6vF8L9wpJFfYa6fK5D4VoZC_45Coue9G0HACIMeta || {},
    component: () => import("/build/incl/pages/fivefest/academy/film-groups/[filmGroupId].vue")
  },
  {
    name: "film-challenge-studios-studioId-teams-create",
    path: "/film-challenge/studios/:studioId()/teams/create",
    meta: createVTWnBRbU0ZYcQQFnEbbzcXhJwN2PZFR9WHiwtdjOutEMeta || {},
    component: () => import("/build/incl/pages/film-challenge/studios/[studioId]/teams/create.vue")
  },
  {
    name: "film-challenge-studios-studioId-teams-teamId",
    path: "/film-challenge/studios/:studioId()/teams/:teamId()",
    meta: _91teamId_93BzC8VqAlxC5IIRKMa_45_45_45jwxN_45q_45e7SQdaNqk8htgvjwMeta || {},
    component: () => import("/build/incl/pages/film-challenge/studios/[studioId]/teams/[teamId].vue")
  }
]